'use client';

import { cn } from '@ifixit/ui/lib/utils';
import type { LabelHTMLAttributes } from 'react';

type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

export function Label({ className, ...props }: LabelProps) {
   return (
      <label
         data-slot="label"
         className={cn(
            'text-sm font-medium leading-none peer-disabled:pointer-events-none peer-disabled:opacity-50',
            className
         )}
         {...props}
      />
   );
}
